/**
 * This is an example of a GrapeUIPlugin that adds functionality to the front-end
 * @kind plugin
 * @class SamplePlugin
 */
class SamplePlugin {
	constructor(Grape, options) {
		this.Grape = Grape;
		this.options = options;

		this.init();
	}

	init ()
	{
		FroalaEditor.DefineIcon('insertAnchorBtn', { NAME: 'mouse', template: 'font_awesome_5' });
		FroalaEditor.RegisterCommand('insertAnchorBtn', {
			title: 'Insert Button',
			focus: true,
			undo: true,
			refreshAfterCallback: true,
			callback: function () {
				this.html.insert(`<a style="border: 1px solid black" href='#'>link button</a>`);
				this.undo.saveStep();
			}
		});

		FroalaEditor.DefineIcon('insertBtn', { NAME: 'link', template: 'font_awesome_5' });
		FroalaEditor.RegisterCommand('insertBtn', {
			title: 'Insert Button',
			focus: true,
			undo: true,
			refreshAfterCallback: true,
			callback: function () {
				this.html.insert(`<button style="">button</button>`);
				this.undo.saveStep();
			}
		});

		//Container
		FroalaEditor.DefineIcon('insertContainer', { NAME: 'square', template: 'font_awesome_5' });
		FroalaEditor.RegisterCommand('insertContainer', {
			title: 'Insert Container',
			focus: true,
			undo: true,
			refreshAfterCallback: true,
			callback: function () {
				this.html.insert(`<div style="max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFFFFF; box-shadow: 0 2px 10px rgba(0,0,0,0.1);"><p></p></div>`);
				this.undo.saveStep();
			}
		});

		// FroalaEditor.ICON_TEMPLATES = {
		// 	font_awesome: '<i class="fa fa-[NAME]" aria-hidden="true"></i>,',
		// 	font_awesome_5: '<i class="fas fa-[FA5NAME]" aria-hidden="true"></i>',
		// 	font_awesome_5s: '<i class="far fa-[FA5NAME]" aria-hidden="true"></i>',
		// 	text: '<span style="text-align: center;">[NAME]</span>',
		// 	image: '<img src=[SRC] alt=[ALT] />',
		// 	svg: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>'
		//   }
	}
}

export default SamplePlugin;
